module.exports = __webpack_public_path__ + "static/img/bg_2_10.dc3e70e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_2_10.png
// module id = 6gMy
// module chunks = 3